module.exports = __webpack_public_path__ + "static/media/Titulo_Carrusel_1024.bc465ed9.png";